import React from 'react';
import styles from './progressbar.module.sass';

const ProgressBar = (props) => {
  let { bgcolor, completed, width, inScore, unFilledColor } = props;

  function scoreColor(score) {
    let scoreColor = '#1f9110';
    if (score > 40) {
      return (scoreColor = '#E84749');
    } else if (score >= 25) {
      return (scoreColor = '#f3be00');
    } else if (score < 25) {
      return scoreColor;
    }
  }

  if (completed > 100) {
    completed = 100;
  } else if (completed == null) {
    completed = 0;
  }

  const inScoreStyle = {
    borderRadius: '0px',
    position: 'absolute',
    bottom: 0,
    left: 1,
    width: 'calc(100% - 2px)',
    height: 16,
    backgroundColor: unFilledColor,
  };

  const containerStyles = {
    width: `${width}px`,
  };

  const fillerStyles = {
    width: `${completed}%`,
    backgroundColor:
      typeof bgcolor === 'number' ? scoreColor(bgcolor) : bgcolor,
  };

  return (
    <div
      className={styles.container}
      style={inScore ? inScoreStyle : containerStyles}
    >
      <div className={styles.filler} style={fillerStyles}>
        <span className={styles.label}></span>
      </div>
    </div>
  );
};

export default ProgressBar;
